import { ICreateCompoundRequest } from 'src/app/inventory/interfaces/create-compound-request';
import { DrugActivitiesToTrackEnum } from '../../interfaces/DrugActivitiesToTrackEnum';
import {IDrugSearchParams} from '../../interfaces/drug-search-params.interface';
import { InventoryInfoRequest } from '../../interfaces/search-criteria';
import { IDrugShort } from '../../interfaces/IDrugShort.interface';
import { ICustomDrug } from '../../interfaces/custom-drug-interface';

export class GetDrugListFromSearch {
  static readonly type = '[Drugs] get drug list for search request (search by product ndc or name, or scanner)';

  constructor(public params: IDrugSearchParams) {
  }
}

export class GetInventoryListFromSearch {
  static readonly type = '[Drugs] get inventory list for search request (search by product ndc or name, or scanner)';

  constructor(public params: InventoryInfoRequest) {
  }
}

export class SetDrugsLoading {
  static readonly type = '[Drugs] set drugs loading';

  constructor(public isLoading: boolean) {
  }
}

export class GetDrugsForDrugsFilter {
  static readonly type = '[Drugs] Get Drugs For Drugs Filter';

  constructor() {
  }
}

export class GetDosageUnits {
  static readonly type = '[Drugs] Get Dosage Units';

  constructor() {
  }
}

export class GetDosageForms {
  static readonly type = '[Drugs] Get Dosage Forms';

  constructor() {
  }
}


export class AddDosageUnit {
  static readonly type = '[Drugs] Add Dosage Unit';

  constructor(public name: string) {
  }
}

export class AddDosageForm {
  static readonly type = '[Drugs] Add Dosage Form';

  constructor(public name: string) {
  }
}

export class GetCustomDrugs {
  static readonly type = '[Drugs] Get Custom Drugs';

  constructor() {
  }
}

export class SetDrugs {
  static readonly type = '[Drugs] Set Drugs';

  constructor(public drugs: IDrugShort[]) {
  }
}

export class AppendCustomDrug {
  static readonly type = '[Drugs] Append Custom Drug';

  constructor(public drug: ICustomDrug) {
  }
}

export class ClearDrugsState {
  static readonly type = '[Drugs] Clear Drugs State';

  constructor() {
  }
}


export class IsCompoundNdcInvalid {
  static readonly type = '[Drugs] Is Compound Ndc Valid';

  constructor(public ndc: string) {
  }
}

export class ClearDrugsFilter {
  static readonly type = '[Drugs] Clear Drugs Filter';

  constructor() {
  }
} 
